import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-192bc1c4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "spot-animation pointer-events-none" }
const _hoisted_2 = ["id", "src"]
const _hoisted_3 = ["id", "src"]

import { reactive, nextTick, computed } from 'vue'
import { useEventBus } from '@vueuse/core'
import { HotSpotData } from './types'
import useImageLoad from '@/composables/useImageLoad'

interface Props {
  index: number
  hotspotData: HotSpotData
  activeHotspotId: string
  hoveredHotspotId: string
  mutedAnimationId: string
  dir: string
}


export default /*#__PURE__*/_defineComponent({
  __name: 'SpotAnimation',
  props: {
    index: null,
    hotspotData: null,
    activeHotspotId: null,
    hoveredHotspotId: null,
    mutedAnimationId: null,
    dir: null
  },
  setup(__props: any) {

const props = __props as {
  index: number
  hotspotData: HotSpotData
  activeHotspotId: string
  hoveredHotspotId: string
  mutedAnimationId: string
  dir: string
}


const popoverClosedBus = useEventBus('popover-closed')
const hotspotHoveredBus = useEventBus('hotspot-hovered')
const hotspotNotHoveredBus = useEventBus('hotspot-not-hovered')
const state = reactive({
  isAnimating: false,
  prefersReducedMotion: matchMedia('(prefers-reduced-motion)').matches,
})

popoverClosedBus.on(() => {
  state.isAnimating = false
})

hotspotHoveredBus.on((index) => {
  if (index == props.index) {
    state.isAnimating = true
  } else {
    state.isAnimating = false
  }
})

hotspotNotHoveredBus.on(() => {
  state.isAnimating = props.activeHotspotId == props.hotspotData.id
})

hotspotHoveredBus.on(() => {
  nextTick(() => {
    if (
      props.hoveredHotspotId != props.hotspotData.id &&
      props.hoveredHotspotId != ''
    ) {
      state.isAnimating = false
    }
  })
})

const animationFileId = computed(() => {
  if (props.hotspotData.animation.fileId) {
    return props.hotspotData.animation.fileId
  } else {
    return props.hotspotData.animation.id
  }
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("img", {
      id: `${props.hotspotData.animation.id}-still`,
      onLoad: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_unref(useImageLoad) && _unref(useImageLoad)(...args))),
      class: _normalizeClass(["absolute max-w-none", {
        block:
          props.mutedAnimationId != ''
            ? props.mutedAnimationId != props.hotspotData.animation.id
            : true,
        hidden:
          props.mutedAnimationId != ''
            ? props.mutedAnimationId == props.hotspotData.animation.id
            : false,
        'opacity-0': state.isAnimating,
        'opacity-100': !state.isAnimating,
      }]),
      "data-test": "still-image",
      style: _normalizeStyle(props.hotspotData.animation.layout),
      src: `/images/${__props.dir}/${_unref(animationFileId)}-still.png`,
      alt: ""
    }, null, 46, _hoisted_2),
    _createElementVNode("img", {
      id: `${props.hotspotData.animation.id}-animation`,
      onLoad: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_unref(useImageLoad) && _unref(useImageLoad)(...args))),
      class: _normalizeClass(["absolute max-w-none", {
        block:
          props.mutedAnimationId != ''
            ? props.mutedAnimationId != props.hotspotData.animation.id
            : true,
        hidden:
          props.mutedAnimationId != ''
            ? props.mutedAnimationId == props.hotspotData.animation.id
            : false,
        'opacity-0': !state.isAnimating,
        'opacity-100': state.isAnimating,
      }]),
      "data-test": "animated-image",
      style: _normalizeStyle(props.hotspotData.animation.layout),
      src: 
        state.prefersReducedMotion
          ? `/images/${__props.dir}/${_unref(animationFileId)}-active.png`
          : `/images/${__props.dir}/${_unref(animationFileId)}.gif`
      ,
      alt: ""
    }, null, 46, _hoisted_3)
  ]))
}
}

})